import { Auth } from 'aws-amplify'
import { consoleError } from 'shared/helpers/consoleError'
import { useLoadingStore } from 'shared/store/toasterSlice'

export const resetCache = async (registerId: number) => {
  const { startLoading, finishWithSuccess, finishWithError } = useLoadingStore.getState()
  try {
    startLoading()
    const currentSession = await Auth.currentSession()
    let accessToken = currentSession.getIdToken()
    let jwt = accessToken.getJwtToken()
    const response = await fetch(`${process.env.REACT_APP_API_ENDPOINT}/reset_cache`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: jwt
      },
      body: JSON.stringify({ registerId: registerId || null })
    })
    const data = await response.json()
    console.log(data)
    finishWithSuccess()
  } catch (error) {
    consoleError(error)
    finishWithError()
  }
}
